<template>
  <div>
    <div class="page-content">
      <div class="container-fluid background">
        <div class="row">
          <img src="~@/assets/images/sunset.jpg" alt="Sunset" class="col-12 p-0">
        </div>
      </div>
      <div class="container content">
        <div class="row">
          <div class="col-12">
            <h1 class="page-header">
              Our Stories
              <hr />
            </h1>
          </div>
          <div class="col-12">
            <p>
              When I had the call from a paramedic to say that my sister had died, it was totally out of the blue.  The shock, disbelief and bewilderment were overwhelming.  However, when I learnt that it had been by suicide I felt that my world had collapsed.  How could she have taken her own life?  She was my sister, my friend and confidante, and we had a lot of fun together – she was planning to visit me the following week.  Why had I not seen any possible signs?  The questions are relentless and all-consuming.  Talking and expressing my feelings freely, with others who have been similarly bereaved, has helped me to come to terms with it, adjust to life without my sister and feel less isolated.
              <br/>
              <strong>Kathryn</strong>
            </p>
            <p>The police called at my door to say that they had received an email from my son to say he was going to take his life.  They were looking for him.  I knew straight away there wasn’t going to be a positive outcome, I just felt it in my heart.  Hours later they returned to tell me that he had been found.  Questions hit me – why didn’t he ring us, why didn’t he ring his wife, brother, a friend; anyone would have calmed him down from the shock he received.  We miss him every day.
            <br/>
              <strong>Linda</strong>
            </p>

            <p>
              It has been some years since I got the call from my uncle telling me that my brother had attempted suicide and was being ventilated in the Intensive Care Unit. I was in deep shock but almost had to ‘bury’ my emotions due to the practicalities, including trying to contact my parents in Spain and organising childcare so we could be with my brother who sadly died within days.
            </p>
            <p>
              Time is a great healer but accepting what happened when he was so young has been hard.
            </p>
            <p>
              I feel privileged to be part of this group of people that have been brave and generous enough to share their experiences which are all unique.  It is good that we all understand and recognise similarities in our situations and can help each other to remember our loved ones with joy and understanding.
              <br/>
              <strong>Maureen</strong>
            </p>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'about-us'
}
</script>

<style lang="scss" scoped>
@import "../../assets/styles/variables/colors";
@import "../../assets/styles/variables/breakpoints";

/****************************
    BANNER
*****************************/
.background {
  margin-top: -64px;
  width: 100%;
  height: 430px;
  border-bottom: 3px solid $primary;

  @media screen and (max-width: $md-breakpoint) {
    height:  300px;
  }

  .row {
    height: 100%;
  }
  .row img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

/****************************
    CONTENT
*****************************/
.content {
  margin-top: 64px;
}

/****************************
    GET IN TOUCH CTA
*****************************/
.cta-banner {
  background-color: $primary;
  padding: 30px 0;

  &-wrapper {
    display: flex;
    align-items: center;

    &:last-child {
      justify-content: flex-end;

      @media (max-width: $lg-breakpoint) {
        justify-content: center;
      }

      @media (max-width: $md-breakpoint) {
        justify-content: flex-start;
      }
    }
  }

  &-title {
    font-size: 40px;
    font-weight: 500;
    color: $white;
  }

  &-content {
    margin: 0;
    font-size: 18px;
    color: $white;
  }

  &-btn {
    background-color: $primary-dark;
    &:hover {
      background-color: $white;
      color: $primary;
    }
  }
}</style>



// WEBPACK FOOTER //
// src/components/pages/AboutUs.vue